import { storeToRefs } from 'pinia';
import { paymentSelectedStore } from '~/stores/paymentSelected';

import type CustomPayment from '~~/constants/customPayment';

export default function () {

  const store = paymentSelectedStore();
  const { paymentSelected } = storeToRefs(store);

  const setPaymentSelected = (paymentSelected: ValueOf<typeof CustomPayment>) => {

    store.setPaymentSelected(paymentSelected);
  
  };

  return {
    ...store,
    paymentSelected,

    setPaymentSelected,
  };

}